import React from 'react';
import { Link } from 'react-router-dom';
import {
    message,
    Table,
    Tabs,
    Radio,
    Button,
    Popover,
    Modal,
    Form,
    Pagination,
    Row,
    Col,
    Icon,
    Input,
    Select,
    DatePicker,
    Spin,
} from 'antd';
const FormItem = Form.Item;
const RangePicker = DatePicker.RangePicker;
const TabPane = Tabs.TabPane;
const RadioGroup = Radio.Group;
const RadioButton = Radio.Button;
import { getMessageList, passedMessage } from './actions';
import { connect } from 'react-redux';
import constant from './constant';
import moment from 'moment';

class TaskMessageList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            page: 1, //分页页码
            pageSize: 10, //分页大小
        };
        this.changePageSize = this.changePageSize.bind(this);
        this.handlePassMessage = this.handlePassMessage.bind(this);
    }

    // 页码改变后的回调
    async changePageSize(pageNumber, pageSize) {
        await this.setState({
            ...this.state,
            page: pageNumber,
            pageSize: pageSize,
        });
        await this.props.getMessageList(this.state);
    }

    async handlePassMessage(value) {
        try {
            await this.props.passedMessage(value);
            message.info('确认消息成功');
            await this.setState({
                ...this.state,
                page: 1,
            });
            await this.props.getMessageList(this.state);
        } catch (e) {
            message.error('确认消息失败');
        }
    }

    componentDidMount() {
        this.props.getMessageList(this.state); //查询操作日志
        console.log(this.props.messagesPage);
    }

    render() {
        let columns = [
            {
                title: '创建/修改者',
                dataIndex: 'userName',
            },
            {
                title: '创建/修改时间',
                dataIndex: 'time',
                render: text => {
                    return moment(text).format('YYYY-MM-DD HH:mm:ss');
                },
            },
            {
                title: '操作类型',
                dataIndex: 'type',
            },
            {
                title: '确认人',
                dataIndex: 'viewer',
            },
            {
                title: '确认时间',
                dataIndex: 'viewedTime',
                render: text => {
                    return text == null ? '' : moment(text).format('YYYY-MM-DD HH:mm:ss');
                },
            },
            {
                title: '操作参数',
                dataIndex: 'task',
                render: (text, record) => (
                    <div>
                        <Popover content={JSON.stringify(text)} title="操作参数">
                            <a>查看</a>
                        </Popover>
                    </div>
                ),
            },
            {
                title: '消息状态',
                dataIndex: 'viewed',
                render: (text, record) => {
                    return record.viewed == 0 ? (
                        <Button
                            type="primary"
                            onClick={() => {
                                this.handlePassMessage(record._id);
                            }}>
                            确认消息
                        </Button>
                    ) : (
                        <Button type="primary" disabled>
                            消息已读
                        </Button>
                    );
                },
            },
        ];
        const { messagesList, loading, messagesPage } = this.props;
        return (
            <div>
                <h2 style={{ marginBottom: '20px' }}>任务通知</h2>
                <Spin spinning={loading} tip="加载中">
                    <Table columns={columns} dataSource={messagesList} pagination={false} bordered />
                    {/*分页部分*/}
                    {messagesPage.total > 0 ? (
                        <Pagination
                            showQuickJumper
                            showSizeChanger
                            className="ant-table-pagination"
                            defaultPageSize={this.state.pageSize}
                            onChange={this.changePageSize}
                            onShowSizeChange={this.changePageSize}
                            current={this.state.page}
                            total={messagesPage.total}
                        />
                    ) : (
                        <Pagination className="ant-table-pagination" />
                    )}
                </Spin>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    loading: state.messageList.ListStatus.loading,
    messagesList: state.messageList.ListMessage,
    messagesPage: state.messageList.ListPage,
});

const mapDispatchToProps = dispatch => ({
    getMessageList: prarms => dispatch(getMessageList(prarms)),
    passedMessage: prarms => dispatch(passedMessage(prarms)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TaskMessageList);



// WEBPACK FOOTER //
// ./pages/user/taskMessage/index.js